(function() {

	angular
		.module('ngmvac')
		.directive('typeaheadcars', Typeaheadcars);

	function Typeaheadcars() {
		return {
			restrict: 'A',
			link: function(scope, element, attrs) {
								
                var destinos = new Bloodhound({
					datumTokenizer: function (data) {
						return Bloodhound.tokenizers.whitespace(data.ciudad);
					},
					queryTokenizer: Bloodhound.tokenizers.whitespace,
					prefetch: {
						url: '/api/destinos_mcr'
					}
				});

				destinos.initialize();

				$(element).typeahead({
					minLength: 1,
					highlight: true,
					hint: false
				},
				{
					name: 'destinos',
					display: 'ciudad',
					templates: {
						header: '<h3 class="h3">DESTINOS</h3>',
						suggestion: function (data) {
							return '<p style="font-size: 15px;"><i class="fa fa-map-marker"></i>' + data.ciudad.toUpperCase() + '</p>';
						}
					},
					source: destinos.ttAdapter(),
				});
			}
		}
	}

})();